<template>
	

	<!-- showChild="true" relative="false" external="true" selectedTheme="white-theme" :theme="selectedTheme"  -->
		<b-col cols="2" class="nevmobileRow" :class="[{'collapsed' : collapsed}]">
				
		<sidebar-menu :menu="menu"  :relative="false"  :show-one-child="true" @toggle-collapse="onToggleCollapse" @item-click="onItemClick">
			
		<div slot="header" class="profile">	
			<div class="btn-reset btnSticky" data-ember-action="" @click="clickHandler" :class="[{'rotateIcocollapsed' : collapsed}]"> </div>	
			<b-row class="m-0"  :class="[{'posmenu' : posmenu}]">
				<b-col cols="12" md="12" class="text-left" > <b-link @click="clickHandler"><i class="fa fa-bars" aria-hidden="true"></i></b-link>
					
				</b-col>
				
			</b-row>	
			<b-row class="m-0">
					<div class="profileP" :class="[{'posmenuProfile' : posmenuProfile}]">
					
					<b-img alt="" v-if="this.$session.get('customer_info').image=='' || this.$session.get('customer_info').image==null" :src="$root.MEDIAPATH+'blank.jpg'" class="img-circle navpp" :class="[{'navppnew' : navppnew}]"></b-img> 
					<b-img   v-else :src="$root.MEDIAPATH+'profiles/'+this.$session.get('customer_info').image" class="img-circle navpp" alt="img" :class="[{'navppnew' : navppnew}]" ></b-img>
					</div>
				
				<!-- <b-col  cols="12" md="8" class="profile--namediv m-1">
					<span class="profile--name"> {{this.$session.get('customer_info').username}} </span>
				</b-col> -->				
			</b-row>
		</div>
		<!--<div slot="footer">footer</div>
		<span slot="toggle-icon">toggle-icon</span>
		<span slot="dropdown-icon">dropdown-icon</span> -->
		<span slot="toggle-icon"  ref="collepsmypanel"><i class="fa fa-arrows-h" aria-hidden="true"></i></span>
		</sidebar-menu>
      </b-col>      
                  
						
                    
               

</template>
<script>
/* const separator = {
  template: `<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">`
};*/
  /* import {
    mdbContainer,
   // mdbRow,
    //mdbIcon,
    mdbTreeview,
    mdbTreeviewItem
  } from "mdbvue"; */
  import '@/assets/nave.scss';
  export default {
    name: "TreeviewPage",
	props: {
		relative: {
		  type: Boolean,
		  default: true
		}
	
	},
    components: {
      //mdbContainer,
     // mdbRow,
      //mdbIcon,
     //mdbTreeview,
      //mdbTreeviewItem
    },
	data() {
		return{
				collapsed: false,
				posmenu: true,
				posmenuProfile: false,
				navppnew: false,
				themes: ['', 'white-theme'],
				selectedTheme: 'white-theme',
				menu: [
				   {
						header: true,
						/*title: 'Example' */
					  },
					  /*{
						title: 'Badge',
						icon: 'fa fa-cog',
						badge: {
						  text: 'new',
						  class: 'default-badge'
						}
					  },*/
					  {
						href: '/influencer/dashboard',
						title: 'Dashboard',
						icon: 'fa fa-dashboard',
						
					  },
					  {
						href: '/influencer/profile',
						title: 'Manage Profile',
						icon: 'fa fa-user',
						
					  },
					  {
						href: '/influencer/wallet',
						title: 'My Wallet',
						icon: 'fa fa-google-wallet',
						
					  },
					   /*{
						href: '',
						title: 'Manage Products',
						icon: 'fa fa-product-hunt',
						child: [
						  {
							href: '',
							title: 'Products',
							icon: 'fa fa-file-alt'
						  },
						  
						]
					  },*/{
						href: '',
						//title: 'Manage Share',
						title: 'Share Products',
						icon: 'fa fa-share-alt',
						child: [
						  {
							href: '/influencer/my-shop',
							//title: 'My Shop',
							title: 'Product Details',
							icon: 'fa fa-file-alt'
						  },{
							href: '/influencer/share-links',
							title: 'Share History',
							icon: 'fa fa-file-alt'
						  },
						  
						]
					  },
					  {
						href: '',
						title: 'Manage Orders',
						icon: 'fa fa-first-order',
						child: [
						  {
							href: '/influencer/orders',
							title: 'Network Orders',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/influencer/myorders',
							title: 'Your Orders',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/influencer/commissions', 
							title: 'Commissions',
							icon: 'fa fa-file-alt'
						  }
						]
					  },
					  {
						href: '',
						title: 'Reports',
						icon: 'fa fa-bar-chart',
						child: [
						  {
							href: '',
							title: 'Order Report',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '',
							title: 'Commission Report',
							icon: 'fa fa-file-alt'
						  }
						  
						]
					  },
					 
							 /* {
								title: 'Multiple Level',
								icon: 'fa fa-list-alt',
								child: [
								  {
									title: 'page'
								  },
								  {
									title: 'Level 2 ',
									child: [
									  {
										title: 'page'
									  },
									  {
										title: 'Page'
									  }
									]
								  },
								  {
									title: 'Page'
								  },
								  {
									title: 'Another Level 2',
									child: [
									  {
										title: 'Level 3',
										child: [
										  {
											title: 'Page'
										  },
										  {
											title: 'Page'
										  }
										]
									  }
									]
								  }
								]
							},
							{
						href: '#disabled',
						title: 'Disabled page',
						icon: 'fa fa-lock',
						disabled: true
					  },
						  {
						header: true,
						component: separator,
						visibleOnCollapse: true
					  },
						{
						header: true,
						title: 'Another Example'
					  },
					  {
						href: '#disabled',
						title: 'Disabled page',
						icon: 'fa fa-lock',
						disabled: true
					  },
					  {
						title: 'Badge',
						icon: 'fa fa-cog',
						badge: {
						  text: 'new',
						  class: 'default-badge'
						}
					  },
					  {
						href: '#page',
						title: 'Dropdown Page',
						icon: 'fa fa-list-ul',
						child: [
						  {
							href: '#sub-page-1',
							title: 'Sub Page 01',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '#sub-page-2',
							title: 'Sub Page 02',
							icon: 'fa fa-file-alt'
						  }
						]
					  },
					  {
						title: 'Multiple Level',
						icon: 'fa fa-list-alt',
						child: [
						  {
							title: 'page'
						  },
						  {
							title: 'Level 2 ',
							child: [
							  {
								title: 'page'
							  },
							  {
								title: 'Page'
							  }
							]
						  },
						  {
							title: 'Page'
						  },
						  {
							title: 'Another Level 2',
							child: [
							  {
								title: 'Level 3',
								child: [
								  {
									title: 'Page'
								  },
								  {
									title: 'Page'
								  }
								]
							  }
							]
						  }
						]
					} */
		]

		};
	},
	methods: {
		onToggleCollapse(collapsed) {
			console.log('Ram Ram'+collapsed);
			 this.collapsed = collapsed;
			 this.posmenuProfile = collapsed;
			 this.navppnew = collapsed;
			 if(!collapsed){
				this.posmenu = true;
				
			 }else{
				this.posmenu = false;
				
			 }
		},
		onItemClick(event, item, node) {
		console.log(event+','+item+','+node);
		}, 	
		clickHandler() {
			this.$refs.collepsmypanel.click();
		}	

	}
	
  };
</script>
<style  lang="scss">



</style>